import { createFileRoute, redirect } from '@tanstack/react-router';
import { parseSignupProduct, type SignupProduct } from '@/lib/signupProduct';
import { SignupPage } from '@/components/auth/SignupPage';
import { getPublicSignupStatus, type PublicSignupStatus } from '@/api/tenants';

/**
 * /signup — formulario único de "Crear cuenta" (rediseño del handoff de Claude Design; reemplaza
 * al wizard de 3 pasos anterior).
 */
export const Route = createFileRoute('/_public/signup')({
  validateSearch: (search: Record<string, unknown>): { product?: SignupProduct } => ({
    product: parseSignupProduct(search.product),
  }),
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ to: '/dashboard' });
    }
  },
  loader: async (): Promise<PublicSignupStatus> => {
    try {
      return await getPublicSignupStatus();
    } catch {
      return { enabled: false };
    }
  },
  component: SignupRoute,
});

function SignupRoute(): JSX.Element {
  const { product } = Route.useSearch();
  const { enabled } = Route.useLoaderData();
  return <SignupPage initialProduct={product} signupEnabled={enabled} />;
}
